import forge from 'node-forge';
import CryptoJS from 'crypto-js';

const aesKey = Date.now() + '' + Math.random().toString().replace('0.', '').slice(0, 3);
// AES 加密方法
// word是加密内容，keyStr是秘钥
// ECB：加密算法，padding：对齐方式
// ciphertext：16进制加密，不加此方法就是Base64加密
export function encrypt(word, keyStr = aesKey) {
  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const srcs = word;
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
}

// var res = JSON.parse(responseBody);
// var pubKey = res.data.pubKey;
// var aesKey = 'nU9IpjpVs6E38380';
// var encryptdata = encrypt(pm.environment.get('password'), aesKey);
// var sign = encryptRsa(pubKey, aesKey);
// pm.environment.set('loginPwd', encryptdata);
// pm.environment.set('sign', sign);
// console.log(sign);

// RSA使用公钥对AES密码进行加密
// 将forgeJS的内容当js代码执行

export function encryptRsa(encrypt_key, clearText = aesKey) {
  // 注意此处上下的BEGIN PRIVATE KEY不要删除，框架自带的
  const public_key = `-----BEGIN PUBLIC KEY-----\n${encrypt_key}\n-----END PUBLIC KEY-----`;
  // public_key = encrypt_key;
  const publicKey = forge.pki.publicKeyFromPem(public_key);
  const buffer = forge.util.createBuffer(clearText, 'utf8');
  const bytes = buffer.getBytes();
  const encryptedText = forge.util.encode64(
    publicKey.encrypt(bytes, 'RSAES-PKCS1-V1_5', {
      md: forge.md.sha1.create(),
      mgf1: {
        md: forge.md.sha1.create()
      }
    })
  );
  return encryptedText;
}
